// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AiProcessPromptOut = zod.object({
  "process_key": zod.string(),
  "prompt_version": zod.string(),
  "response_schema": zod.record(zod.string(), zod.unknown()),
  "system": zod.string(),
  "user": zod.string()
});

export type AiProcessPromptOut = zod.input<typeof AiProcessPromptOut>;
export type AiProcessPromptOutOutput = zod.output<typeof AiProcessPromptOut>;
